import CloseIcon from "@mui/icons-material/Close";
import {
  Alert,
  Box,
  Grid,
  Paper,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import DisplayMoney from "../../../common/custom/DisplayMoney";
import CustomTable from "../../../common/tables/table";
import {
  ApplicantAssessementAuditDto,
  ApplicantViewDto,
} from "../../applicant/Models";
import { GuardianAssessementAuditItemDto } from "../models";

interface Props {
  applicant: ApplicantViewDto | undefined;
}

export default function ApplicantAssessementHistory({ applicant }: Props) {
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);
  const [page, setPage] = useState<number>(0);

  const columns = [
    "#",
    "Status From",
    "Status To",
    "Change Reason",
    "Change Date",
    "Application Stage",
    "User",
  ];

  const createTableRows = () => {
    return (
      <>
        {applicant &&
          applicant.applicantAssessementAudit &&
          applicant.applicantAssessementAudit
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((record: ApplicantAssessementAuditDto, key: React.Key) => {
              return (
                <TableRow key={key}>
                  <TableCell>{parseInt(key.toString()) + 1}</TableCell>
                  <TableCell>
                    {record.applicationStatusFrom
                      .replace(/([A-Z])/g, " $1")
                      .trim()}
                  </TableCell>
                  <TableCell>
                    {record.applicationStatusTo
                      .replace(/([A-Z])/g, " $1")
                      .trim()}
                  </TableCell>
                  <TableCell>{record.changeReason}</TableCell>
                  <TableCell>
                    {moment(record.changeDateTime).format("YYYY/MM/DD")}
                  </TableCell>
                  <TableCell>
                    {record.applicationStage.replace(/([A-Z])/g, " $1").trim()}
                  </TableCell>
                  <TableCell>{record.createdUser}</TableCell>
                </TableRow>
              );
            })}
      </>
    );
  };

 

  return (
    <>
      {applicant && applicant.applicantAssessementAudit && (
        <Box sx={{ marginLeft: -3, marginTop: 2 }}>
          <CustomTable
            columns={columns}
            data={applicant.applicantAssessementAudit}
            rowsPerPage={rowsPerPage}
            setPage={setPage}
            setRowsPerPage={setRowsPerPage}
            rows={() => createTableRows()}
            page={page}
          />
        </Box>
      )}

      
    </>
  );
}
